<template>
    <div>
        <div v-if="task">
            <TaskProjectTable :meta_task_data="meta_task" :meta_template_data="meta_template" :UpdatedListOfLiveTask="ListOfLiveTaskUpdate" :UpdatedListOfTask="ListOfTaskUpdate" ref="taskProjectTable" @passEvent="passEvent($event)" @openModalSectionLive="openModalSectionLive($event)" class="mt-4"/>
        </div>
        <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup" v-if="openUpdateModal" :class="{show: openUpdateModal}">
            <div class="cstm-modal">
                <div class="header">
                    <h3>Task Details</h3>
                    <button @click="closeUpdateModal" class="close-modal">&times;</button>
                </div>
                <div class="each-tabular p-4">
                    <div class="cstm-unique-tab-text modal-content">
                        <div class="px-2">
                            <div class="flex flex-wrap -mx-2">
                                <div class="md:w-1/2 w-full px-2 my-2">
                                   <strong class="block">Name:</strong> {{taskData.name}}
                                </div>
                                <div class="md:w-1/2 w-full px-2 my-2">
                                <v-select
                                    v-model="taskData.task_priority_id"
                                    v-validate="'required'"
                                    :reduce="option => option.id"
                                    label="level"
                                    name="level"
                                    :options="priority"
                                    :disabled="true"
                                    placeholder="Choose Priority"
                                    style="width:100%;"
                                /> 
                                </div>
                                 <div class="w-full px-2 my-2">
                                   <select v-model="taskData.task_status_id" @change="StatusChnage(taskData)" name="cars" id="cars" form="carform" class="w-100 selectExample mt-2 customSelect">
      <option :key="index" :value="item.id" :label="item.status" v-for="(item,index) in options" class="selectOptionclass"/>
    </select>
                                </div>
                                <div class="w-full px-2 my-2">
                                  <strong class="block">Details:</strong>  {{taskData.details}}
                                </div>
                                <div class="md:w-1/2 w-full px-2 my-2">
                                    <div class="person-holder">
                                        <div class="w-full">
                                            <feather-icon icon="UserIcon" />
                                            <strong>Responsible Person</strong>
                                        </div>
                                        <div class="flex-wrap">
                                            <span class="mr-1" :key="index4" v-for="(person, index4) in responsibleData" >
                                                {{person.first_name}} {{person.last_name}}
                                                <span v-if="index4+1 < responsibleData.length">,</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="md:w-1/2 w-full px-2 my-2">                                
                                    <strong class="block">Deadline:</strong>
                                    {{taskData.due_date}}
                                                                    
                                </div>
                                <vs-divider />
                                <vs-tabs class="inner-tab tooltip_icon_tab">
                                    <vs-tab label="Created By" icon-pack="feather" icon="icon-users">
                                       <div class="my-2">
                              <div class="flex items-center">
                                  <feather-icon icon="UserIcon" />
                                  <span class="mx-1">Created By</span>
                              </div>
                              <div class="flex flex-wrap -mx-2">
                                  <div class="w-full px-2">
                                    <strong class="block my-2">{{taskData.created_by.first_name}} {{taskData.created_by.last_name}}</strong>
                                  </div>
                              </div>
                          </div>

                          <div class="my-2">
                              <div class="flex items-center">
                                  <feather-icon icon="UserIcon" />
                                  <span class="mx-1">Participants</span>
                              </div>
                              <div class="flex flex-wrap -mx-2">
                                  <div class="cstm-inp flex-wrap">
                                    <span class="cstm-badge flex items-center mb-2" :key="index4" v-for="(person, index4) in participantData">
                                                              {{person.first_name}} {{person.last_name}}
                                                          </span>                
                                  </div>
                              </div>
                          </div>

                                        <div class="my-2">
                              <div class="flex items-center">
                                  <feather-icon icon="UserIcon" />
                                  <span class="mx-1">Observers</span>
                              </div>
                              <div class="flex flex-wrap -mx-2">
                                  <div class="cstm-inp flex-wrap">
                                      <span class="cstm-badge flex items-center mb-2" :key="index4" v-for="(person, index4) in observerData">
                                                              {{person.first_name}} {{person.last_name}}
                                                          </span>
                                  </div>
                              </div>
                          </div>
                                    </vs-tab>

                                    <vs-tab label="Time Planning" icon-pack="feather" icon="icon-clock">
                                        <div>
                                            <div class="flex items-center my-2">
                                                <feather-icon icon="ClockIcon" />
                                                <span class="mx-1">Time Planning</span>
                                            </div>
                                            From: {{taskData.from_time}} &nbsp;<br>
                                            To: {{taskData.to_time}}
                                            <vs-divider />
                                            <div v-if="taskData.is_tracking_active">
                                            <div v-if="participantData.find(u => u.id == userInfo.basic_details.client_users_id)">
                                                <div class="flex items-center my-2">
                                                    <feather-icon icon="ClockIcon" />
                                                    <span class="mx-1">Log</span>
                                                </div>
                                            <div class="flex flex-wrap items-center" :key="index10" v-for="(log, index10) in logs">
                                                <vs-input class="width-10" v-model="log.no_of_days" type="number" />
                                                <span class="mx-2">Days</span>
                                                <vs-input class="width-10" v-model="log.no_of_hours" type="number" />
                                                <span class="mx-2">Hour</span>
                                            </div><br>
                                            <vs-button @click="addLog">+ Log</vs-button>&nbsp;
                                            <vs-button color="success" @click="submitLog(live_update_id)">Save</vs-button>
                    
                                            <div>
                                                <div class="flex items-center my-2">
                                                    <feather-icon icon="ClockIcon" />
                                                    <span class="mx-1">Log History</span>
                                                    </div>
                                                    <div class="cstm-badge flex items-center" :key="index10" v-for="(log, index10) in logHistory">
                                                {{log.no_of_days}}
                                                <span class="mx-2">Days</span>
                                                {{log.no_of_hours}}
                                                <span class="mx-2">Hour</span>
                                            </div>
                                            <br>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </vs-tab>

                                     <vs-tab label="Assignment" icon-pack="feather" icon="icon-list">
                        <span v-if="taskData.checklist.length !== 0">
                                                <span :key="index8" v-for="(item1, index8) in taskData.checklist">
                                                  <div class="flex flex-wrap items-center">
                                                  <div class="flex items-center my-2 lg:w-1/5 w-full">
                                                        <span class="material-icons">assignment</span>
                                                        <span class="mx-2">{{item1.name}}</span>
                                                  </div>
                                                      <vs-progress class="lg:w-1/2 md:w-3/5" :percent="(item1.itemStatusCal.length/item1.todos.length)*100" color="primary"></vs-progress>
                                                      <div class="progress-status">
                                                          Completed: {{item1.itemStatusCal.length}} out of {{item1.todos.length}}
                                                      </div>
                                                  </div>
                                                      <ul class="task-checklist mb-4" >
                                                      <li class="flex justify-between"  :key="index9" v-for="(item2, index9) in item1.todos">
                                                        {{item2.todo}}
                                                      </li> 
                                                      </ul>
                                                </span>  
                                            </span>
                      </vs-tab>

                                    <vs-tab label="Project" icon-pack="feather" icon="icon-grid">
                          <div>
                              <div class="flex flex-wrap items-center">
                                  <label class="w-1/5">Project</label>
                                  <div class="cstm-inp w-1/2">
                                               <span v-if="showDataForProject"> {{showDataForProject.name}}</span>
                                                </div>
                              </div>
                              <vs-divider />

                              <div class="flex flex-wrap items-center">
                                  <label class="w-1/5">Remind about task</label>
                                  <div class="inline-flex items-center m-1" :key="index" v-for="(item, index) in reminderTime">
                                                            {{item.reminder_time}}
                                                        </div>
                              </div>
                              <vs-divider />

                              <div class="flex flex-wrap items-center">
                                  <label class="w-1/5">Gantt</label>
                              </div>
                              <vs-divider />

                              <div class="flex flex-wrap items-center">
                                  <label class="w-1/5">CRM</label>
                                   <span class="cstm-badge flex items-center" :key="index8" v-for="(crm, index8) in selectedCRMData">
                                                        <span v-if="crm.lead_first_name != ''">{{crm.lead_first_name}}</span><span v-if="crm.lead_middle_name != ''">&nbsp;{{crm.lead_middle_name}}</span><span v-if="crm.lead_last_name != ''">&nbsp;{{crm.lead_last_name}}</span>
                                                    </span>
                              </div>
                              <vs-divider />

                              <div class="flex flex-wrap items-center">
                                  <label class="w-1/5">SubTask</label>
                                  <span class="cstm-badge flex items-center" :key="index8" v-for="(task, index8) in selectedSubTaskData">
                                                        {{task.name}}
                                                    </span>
                              </div>
                              <vs-divider />

                              <div class="flex flex-wrap items-center">
                                  <label class="w-1/5">Tags</label>
                                   <v-select
                                                            class="w-full"
                                                            label="name"
                                                            taggable
                                                            :reduce="(option) => option.name"
                                                            :create-option="
                                                            (option) => ({ id: option, label: option, name: option })
                                                            "
                                                            :options="tagsList"
                                                            v-model="taskData.tags"
                                                            :clearable="false"
                                                            data-vv-name="name"
                                                            name="name"
                                                            :disabled="true"
                                                            multiple
                                                        >
                                                        </v-select>
                              </div>
                            
                          </div>
                      </vs-tab>
                                   <vs-tab label="Editor" icon-pack="feather" icon="icon-type">
                        <div class="flex items-center">
                          <p v-html="taskData.comments"></p>
                        </div>
                      </vs-tab>
                                </vs-tabs>
                             
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </div>
  
    </div>
</template>
<script>
import { TaskProject } from './mixins/task-project.js'
import ProjectCreate from './project-create.vue'
import TaskProjectTable from './components/task-project-table.vue'
import { Project } from './mixins/project.js'
export default {
  mixins: [
    TaskProject,
    Project
  ],
  components: {
    ProjectCreate,
    TaskProjectTable
  },
  data () {
    return {
      options: [
        {id: 1, status: 'To Do'},
        {id: 2, status: 'In Progress'},  
        {id: 3, status: 'Done'}
      ],
      customer_id:parseInt(localStorage.getItem('customer_id'))
    }
  },
  computed: {
    buttonActive () {
      if (this.responsibleData.length !== 0 && this.taskData.name !== '' && this.taskData.task_priority_id !== '' && this.taskData.due_date !== '' && this.taskData.details !== '') {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    this.customer_id = this.$refs.taskProjectTable.$data.customer_id
    this.fetchProject(this.meta)
    this.priorityList()
  },
  methods: {
    closeUpdateModal () {
      this.clearData()
      this.openUpdateModal = false
    },
    passEvent (data) {
      this.fetchTaskUpdate(data)
    }
  }
}
</script>
<style>
.userModalStyle
{
  z-index: 100000;
}
.customSelect {
    border-radius:3px;
    border: 1px solid #CCCCCC;
    width: 100%;
    height:30px;
    background-color: white;
    color:#757575
    /* font-family: $font-family-base'; */
  }
  .selectOptionclass :hover
  {
    background-color:yellow;
    color:white;
    border:none;
  }
</style>